/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addCustomerHatchery } from '../fn/customer-hatchery/add-customer-hatchery';
import { AddCustomerHatchery$Params } from '../fn/customer-hatchery/add-customer-hatchery';
import { CustomerHatchery } from '../models/customer-hatchery';
import { deleteCustomerHatchery } from '../fn/customer-hatchery/delete-customer-hatchery';
import { DeleteCustomerHatchery$Params } from '../fn/customer-hatchery/delete-customer-hatchery';
import { findByBusinessNumber_1 } from '../fn/customer-hatchery/find-by-business-number-1';
import { FindByBusinessNumber_1$Params } from '../fn/customer-hatchery/find-by-business-number-1';
import { findByCustomerHatcheryId } from '../fn/customer-hatchery/find-by-customer-hatchery-id';
import { findByCustomerHatcheryId_1 } from '../fn/customer-hatchery/find-by-customer-hatchery-id-1';
import { FindByCustomerHatcheryId_1$Params } from '../fn/customer-hatchery/find-by-customer-hatchery-id-1';
import { FindByCustomerHatcheryId$Params } from '../fn/customer-hatchery/find-by-customer-hatchery-id';
import { findById_1 } from '../fn/customer-hatchery/find-by-id-1';
import { FindById_1$Params } from '../fn/customer-hatchery/find-by-id-1';
import { findByName_1 } from '../fn/customer-hatchery/find-by-name-1';
import { FindByName_1$Params } from '../fn/customer-hatchery/find-by-name-1';
import { setActiveCustomer_1 } from '../fn/customer-hatchery/set-active-customer-1';
import { SetActiveCustomer_1$Params } from '../fn/customer-hatchery/set-active-customer-1';
import { updateCustomerHatchery } from '../fn/customer-hatchery/update-customer-hatchery';
import { UpdateCustomerHatchery$Params } from '../fn/customer-hatchery/update-customer-hatchery';

@Injectable({ providedIn: 'root' })
export class CustomerHatcheryService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `addCustomerHatchery()` */
  static readonly AddCustomerHatcheryPath = '/api/customer/hatchery';

  /**
   * Add Customer Hatchery.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addCustomerHatchery()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addCustomerHatchery$Response(params: AddCustomerHatchery$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerHatchery>> {
    return addCustomerHatchery(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Customer Hatchery.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addCustomerHatchery$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addCustomerHatchery(params: AddCustomerHatchery$Params, context?: HttpContext): Observable<CustomerHatchery> {
    return this.addCustomerHatchery$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerHatchery>): CustomerHatchery => r.body)
    );
  }

  /** Path part for operation `findByBusinessNumber_1()` */
  static readonly FindByBusinessNumber_1Path = '/api/customer/hatchery/businessNumber/{businessNumber}/zipCode/{zipCode}';

  /**
   * Find By Business Number.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByBusinessNumber_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByBusinessNumber_1$Response(params: FindByBusinessNumber_1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerHatchery>>> {
    return findByBusinessNumber_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Find By Business Number.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findByBusinessNumber_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByBusinessNumber_1(params: FindByBusinessNumber_1$Params, context?: HttpContext): Observable<Array<CustomerHatchery>> {
    return this.findByBusinessNumber_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CustomerHatchery>>): Array<CustomerHatchery> => r.body)
    );
  }

  /** Path part for operation `findById_1()` */
  static readonly FindById_1Path = '/api/customer/hatchery/customerHatchery/{customerHatcheryId}';

  /**
   * Find By Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById_1$Response(params: FindById_1$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerHatchery>> {
    return findById_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Find By Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findById_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById_1(params: FindById_1$Params, context?: HttpContext): Observable<CustomerHatchery> {
    return this.findById_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerHatchery>): CustomerHatchery => r.body)
    );
  }

  /** Path part for operation `findByName_1()` */
  static readonly FindByName_1Path = '/api/customer/hatchery/name/{name}';

  /**
   * Find By Name.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByName_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByName_1$Response(params: FindByName_1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerHatchery>>> {
    return findByName_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Find By Name.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findByName_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByName_1(params: FindByName_1$Params, context?: HttpContext): Observable<Array<CustomerHatchery>> {
    return this.findByName_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CustomerHatchery>>): Array<CustomerHatchery> => r.body)
    );
  }

  /** Path part for operation `updateCustomerHatchery()` */
  static readonly UpdateCustomerHatcheryPath = '/api/customer/hatchery/{customerHatcheryId}';

  /**
   * Update Customer Hatchery.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCustomerHatchery()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCustomerHatchery$Response(params: UpdateCustomerHatchery$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerHatchery>> {
    return updateCustomerHatchery(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Customer Hatchery.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCustomerHatchery$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCustomerHatchery(params: UpdateCustomerHatchery$Params, context?: HttpContext): Observable<CustomerHatchery> {
    return this.updateCustomerHatchery$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerHatchery>): CustomerHatchery => r.body)
    );
  }

  /** Path part for operation `deleteCustomerHatchery()` */
  static readonly DeleteCustomerHatcheryPath = '/api/customer/hatchery/{customerHatcheryId}';

  /**
   * Delete Customer Hatchery.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCustomerHatchery()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCustomerHatchery$Response(params: DeleteCustomerHatchery$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerHatchery>> {
    return deleteCustomerHatchery(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Customer Hatchery.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCustomerHatchery$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCustomerHatchery(params: DeleteCustomerHatchery$Params, context?: HttpContext): Observable<CustomerHatchery> {
    return this.deleteCustomerHatchery$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerHatchery>): CustomerHatchery => r.body)
    );
  }

  /** Path part for operation `setActiveCustomer_1()` */
  static readonly SetActiveCustomer_1Path = '/api/customer/hatchery/{customerHatcheryId}/setActive={isActive}';

  /**
   * Set Active Customer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setActiveCustomer_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  setActiveCustomer_1$Response(params: SetActiveCustomer_1$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerHatchery>> {
    return setActiveCustomer_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Set Active Customer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setActiveCustomer_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setActiveCustomer_1(params: SetActiveCustomer_1$Params, context?: HttpContext): Observable<CustomerHatchery> {
    return this.setActiveCustomer_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerHatchery>): CustomerHatchery => r.body)
    );
  }

  /** Path part for operation `findByCustomerHatcheryId()` */
  static readonly FindByCustomerHatcheryIdPath = '/api/customer/hatchery/{customerId}';

  /**
   * Find By Customer Hatchery Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByCustomerHatcheryId()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByCustomerHatcheryId$Response(params: FindByCustomerHatcheryId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerHatchery>>> {
    return findByCustomerHatcheryId(this.http, this.rootUrl, params, context);
  }

  /**
   * Find By Customer Hatchery Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findByCustomerHatcheryId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByCustomerHatcheryId(params: FindByCustomerHatcheryId$Params, context?: HttpContext): Observable<Array<CustomerHatchery>> {
    return this.findByCustomerHatcheryId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CustomerHatchery>>): Array<CustomerHatchery> => r.body)
    );
  }

  /** Path part for operation `findByCustomerHatcheryId_1()` */
  static readonly FindByCustomerHatcheryId_1Path = '/api/customer/hatchery/{customerId}/hatchery/{hatcheryId}';

  /**
   * Find By Customer Hatchery Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByCustomerHatcheryId_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByCustomerHatcheryId_1$Response(params: FindByCustomerHatcheryId_1$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerHatchery>> {
    return findByCustomerHatcheryId_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Find By Customer Hatchery Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findByCustomerHatcheryId_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByCustomerHatcheryId_1(params: FindByCustomerHatcheryId_1$Params, context?: HttpContext): Observable<CustomerHatchery> {
    return this.findByCustomerHatcheryId_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerHatchery>): CustomerHatchery => r.body)
    );
  }

}
